import { environment } from '../../environments/environment';
import { Observable, throwError } from 'rxjs';
import { Injectable } from '@angular/core';

import { IDepartment, IUserDepartment } from './user-department.model';
import { IUserInfo, AuthService } from '../shared/core/index';
import { ILookup } from '../shared/lookup';
import { HttpService } from '../shared/core/http.service';
import { map } from 'rxjs/internal/operators/map';
import { tap } from 'rxjs/internal/operators/tap';
import { catchError } from 'rxjs/internal/operators/catchError';

@Injectable()
export class UserDepartmentService {

    private _userInfo: IUserInfo;    
    private _userDepartmentAPIUrl = new URL('userdepartment', environment.apiUrl).toString();

    titles: ILookup[];

    constructor(private _httpService: HttpService, private authService: AuthService) {
        this.authService.subscribeToLoginService().subscribe(r => { this._userInfo = r });
    }

    getDepartments(): Observable<IUserDepartment> {
        const url = new URL(this._userDepartmentAPIUrl).toString();

            return this._httpService.httpGet(url).pipe(
                map((response) => {
                    return this.mapDepartments(response);
                }),
                tap(data => data),
                catchError(this.handleError)
            );
    }

    mapDepartments(response: any): IUserDepartment {
        return this.toDepartment(response);
    }

    toDepartment(r: any): IUserDepartment {
        
        let departments = <IUserDepartment>
            ({
                email: r.Email
            });  

            departments.userDepartments = new Array<IDepartment>();    
        if (r.UserDepartments) {
            r.UserDepartments.forEach(element => {
                var userDepartment: IDepartment = new IDepartment();
                userDepartment.department = element.Department;
                departments.userDepartments.push(userDepartment);
            });
        }

        return departments;
    }

    private handleError(error) {
        return throwError(() => error || 'Server error');
    }
}
